module.exports = __webpack_public_path__ + "img/careLogo.a2393074.png";